// BreadcrumbContext.js
import React, { createContext, useContext, useState } from 'react';
import { Breadcrumb} from "../utils/types/ui";


const BreadcrumbContext = createContext({} as any);

export const useBreadcrumb = () => useContext(BreadcrumbContext);

interface Props {
    children: React.ReactNode;
}

export const BreadcrumbProvider = ({ children }: Props) => {
    const [breadcrumb, setBreadcrumb] = useState({ base: 'Home', inner: [''] } as Breadcrumb);

    return (
        <BreadcrumbContext.Provider value={{ breadcrumb, setBreadcrumb }}>
            {children}
        </BreadcrumbContext.Provider>
    );
};
